import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { DetailedEntityDataService } from '../../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-data.service';
import { CoreServiceRegistry } from '../../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../../shared/shared-service-registry';
import { DetailedEntityBackendService } from '../../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-backend.service';
import { CommodityDataService } from './commodity-data.service';
import { HttpHeaders } from '@angular/common/http';
import { CommodityLocData } from '../../../../../shared/models/commodityloc-data.model';
import { LotLocMovableUnitData } from '../../../../../shared/models/lotlocmovableunit-data.model';
import { LotBalanceData } from '../../../../../shared/models/lot-balance.model';
import { LoaderEnabled } from 'sce-core';

@Injectable()
export class CommodityBackendService extends DetailedEntityBackendService {

  protected dataService: CommodityDataService;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  // service call to save an entity detail while creating
  @LoaderEnabled()
  public saveCommodityforAdd(entityProperties: any, advancedConfigData, skuInfoData, skuInfoExtendedData) {
    let request;
    // create mode with advance config data nad skuinfodata
    request = [{
      'moduleProperties': entityProperties,
      'screenType': this.dataService.primarySearchParams.tableId,
      'detailItems': []
    }];
    if (advancedConfigData.length > 0) {
      advancedConfigData.forEach(data => {
        request.push(data);
      });
    }
    if (skuInfoData.length > 0) {
      skuInfoData.forEach(data => {
        request.push(data);
      });
    }
    if (skuInfoExtendedData.length > 0) {
      skuInfoExtendedData.forEach(data => {
        request.push(data);
      });
    }
    const response$ = this.http$.post(`api/setup/`, JSON.stringify(request))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400) {
            return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
          }
        }
      });
    return response$;
  }

   // service call to save an entity detail after editing
   public saveCommodityforUpdate(entityProperties: any, advancedConfigData, skuInfoData, skuInfoExtendedData) {
    let request;
    // create mode with advance config data nad skuinfodata
    request = [{
      'moduleProperties': entityProperties,
      'screenType': this.dataService.primarySearchParams.tableId,
      'detailItems': []
    }];
    if (advancedConfigData.length > 0) {
      advancedConfigData.forEach(data => {
        request.push(data);
      });
    }
    if (skuInfoData.length > 0) {
      skuInfoData.forEach(data => {
        request.push(data);
      });
    }
    if (skuInfoExtendedData.length > 0) {
      skuInfoExtendedData.forEach(data => {
        request.push(data);
      });
    }
    const response$ = this.http$.put(`api/setup/`, JSON.stringify(request))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400) {
            return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
          }
        }
      });
    return response$;
  }

  // service call to delete selected line items of an entity
  public deleteSelectedLineItemFromAdvConfig(request: any): Observable<Response> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: request,
    };
    const response$ = this.http$.delete('api/setup/', options)
      .map((response: any) => {
        if (response['errors']) {
          if (response['errors'][0].validationCode !== 200) {
            return Observable.throw(response['errors'][0].validationMessage);
          }
        } else {
          return response;
        }
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  // service call to delete all line items of an entity
  public deleteAllLineItemsFromEntity(payload: any): Observable<Response> {

    const response$ = this.http$.post(`api/data/deleteall`, JSON.stringify(payload))
      .map((response: any) => {
        if (response['errors']) {
          if (response['errors'][0].validationCode !== 200) {
            return Observable.throw(response['errors'][0].validationMessage);
          }
        } else {
          return response;
        }
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  public autoPopulateUOMFeilds(reqObj: any) {
    const response$ = this.http$.put('api/asn/UOM/compute/', JSON.stringify(reqObj))
        .map((response: any) => {
            return response;
        })
        .catch((error: any) => {
            if (error.error.errors.length !== 0) {
                if (error.error.errors[0].validationCode !== 200) {
                    return Observable.throw(error.error.errors['0'].validationMessage);
                }
            }
        });
    return response$;
}

// method to find the lot balance
 public getAllLotBalance(sku, storerKey): Observable<LotBalanceData> {
   // LFWM-3191- passing tableId and screenType 
   const tableId = this.dataService.detailsSearchParams.tableId;
   const screenType = '';
    const response$ = this.http$.get(`api/asn/`+ tableId + `/` + screenType + `/` + storerKey  + `/` + sku + `/lot/balance`)
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  // method to find the LotLocMovable balance
  public getAllLotLocMUBalance(sku: any, storerKey: any): Observable<LotLocMovableUnitData> {
    // LFWM-3191- passing tableId and screenType 
    const tableId = this.dataService.detailsSearchParams.tableId;
    const screenType = '';
    const response$ = this.http$.get(`api/asn/`+ tableId + `/` + screenType + `/` + storerKey + `/` + sku + `/LotLocMovable/balance`)
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

    // method to find the loc balance
  public getAllCommodityLocData(sku: any, storerKey: any): Observable<CommodityLocData> {
    // LFWM-3191- passing tableId and screenType 
    const tableId = this.dataService.detailsSearchParams.tableId;
    const screenType = '';
    const response$ = this.http$.get(`api/asn/`+ tableId + `/` + screenType + `/` + storerKey + `/` + sku + `/loc/balance`)
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

public populateRestrictedValuesNew(itemId: any) {
  const request = {
      'propertyName': 'packKey',
      'key': itemId
  };
  // LFWM-3191- adding tableId
  const tableId = this.dataService.primarySearchParams.tableId;

      //LFWM-4761-Code-starts
      const itemIdEncodedValue = btoa(itemId);
      //LFWM-4761-Code-ends

  const response$ = this.http$.get('api/core/uom/pack/' + itemIdEncodedValue + '/' + tableId)
      .map((response: any) => {
          return response;
      })
      .catch((error: any) => {
          if (error.error.errors.length !== 0) {
              if (error.error.errors[0].validationCode !== 200) {
                  return Observable.throw(error.error.errors['0'].validationMessage);
              }
          }
      });
  return response$;
}

/* LFWM-1914 - Function to upload sku images */
public uploadAsnSkuImages(files: File[], storerKey: string, sku: string) {
  return this.sharedServiceRegistry.fileUtilityService.uploadFiles(files,
    'api/upload/image/SKU/' + storerKey.trim() + '/' + sku.trim() + '/');
}
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/setup/customer/commodity/service/commodity-backend.service.ts